<template>
    <div v-if="selectedLocation.teaser" class="teaser-promo-block">
        <div class="teaser-promo-block-container">
            <div v-if="selectedLocation.teaser.imageUrl" class="teaser-promo-block-image">
                <img :src="selectedLocation.teaser.imageUrl" :alt="selectedLocation.teaser.imageAltText || ''">
            </div>
            <div class="teaser-promo-block-info">
                <h5>{{selectedLocation.teaser.title}}</h5>
                <div class="heading" v-html="selectedLocation.teaser.content"></div>
                <button type="button" class="btn btn-secondary" @click="onPromoBlockCTAClick">{{selectedLocation.teaser.ctaText}}</button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        selectedLocation: {
            get() {
                return this.$store.getters.selectedLocation;
            }
        },
    },
    methods: {
        onPromoBlockCTAClick() {
            window.open(this.selectedLocation.teaser.ctaUrl)
        }
    }
};
</script>
